import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UserInvitation } from '../types/users.types';

@Component({
  selector: 'app-user-invitation',
  templateUrl: './user-invitation.component.html',
  styleUrls: ['./user-invitation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInvitationComponent {
  @Input()
  public canManageInvitations: boolean | null;

  @Input()
  public userInvitation: UserInvitation;

  @Input()
  public whitelabelTemplate?: boolean;

  @Output()
  public resend: EventEmitter<UserInvitation> = new EventEmitter();

  @Output()
  public cancel: EventEmitter<UserInvitation> = new EventEmitter();

  @Output()
  public delete: EventEmitter<UserInvitation> = new EventEmitter();

  public invitationStatuses = UserInvitation.Status;

  public get hasReinviteButton(): boolean {
    return (
      this.userInvitation.status === UserInvitation.Status.EXPIRED ||
      this.userInvitation.status === UserInvitation.Status.ERROR ||
      this.userInvitation.status === UserInvitation.Status.CANCELLED
    );
  }
}
